export function componentsLoader() {
	const context = require.context('./shapes/', true, /\.js$/);

	const obj = {};
	context.keys().forEach(key => {
		const content_type = key.split('/')[2].replace('.js', '');
		obj[content_type] = context(key).default;
	});

	return obj;
}
